<app-manual-title-insurance-header
	*ngIf="showHeader"
	[company]="company"
	[companyLogo]="companyLogo"
></app-manual-title-insurance-header>
<div class="flex w-full justify-center">
	<div class="flex flex-col w-full max-w-6xl">
		<div class="flex gap-2 items-center justify-between mt-1">
			<hr class="w-5/12 mt-2" />
			<p class="text-lg font-bold text-center">Order summary</p>
			<hr class="w-5/12 mt-2" />
		</div>

		<div class="flex justify-between items-center mt-3">
			<app-order-number></app-order-number>
			<div class="h-12 border-l border-grey-veryLight"></div>
			<app-order-date></app-order-date>
			<div class="h-12 border-l border-grey-veryLight"></div>
			<app-effective-date></app-effective-date>
		</div>
	</div>
</div>

<div class="flex gap-10 mt-10">
	<div class="w-2/3 flex flex-col gap-4">
		<div class="flex flex-col gap-2">
			<div class="flex gap-2 items-center">
				<p class="font-bold text-lg">Total amount</p>
			</div>
			<div class="border border-grey-lighter rounded-lg p-2">
				<div class="flex justify-between items-center">
					<h2 class="text-green">
						{{ amountDueByClient$ | async | centsToDollars }}
					</h2>
					<div class="h-12 border-l border-grey"></div>
					<app-premium-amount></app-premium-amount>
					<app-counsel-credit></app-counsel-credit>
				</div>
			</div>
		</div>
		<div
			*ngIf="
				!allLenderPoliciesHavePriority || !allLenderPoliciesHaveUniquePriority
			"
			class="flex flex-col gap-3 mb-3"
			[@openClose]
		>
			<atomic-message-bar
				type="error"
				*ngIf="!allLenderPoliciesHavePriority"
				[@openClose]
				[testHook]="testHooks.MessageBar"
				>Not all lender policies have a priority assigned.</atomic-message-bar
			>
			<atomic-message-bar
				type="error"
				*ngIf="!allLenderPoliciesHaveUniquePriority"
				[@openClose]
				[testHook]="testHooks.MessageBar1"
				>All lender policies must have unique priorities.</atomic-message-bar
			>
		</div>
		<app-title-insurance-policies></app-title-insurance-policies>
	</div>
	<app-title-insurance-documents
		type="dropzone"
	></app-title-insurance-documents>
</div>
